<script lang="ts">
  import { flagValue } from '$lib/context/flags';
  import { FEATURE_FLAGS } from '$lib/flags/constants';

  let brandReskinEnabled = $derived(flagValue(FEATURE_FLAGS.BRAND_RESKIN));
</script>

{#if brandReskinEnabled}
  <svg
    width="116"
    height="35"
    viewBox="0 0 116 35"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-labelledby="blockLogo"
  >
    <title id="blockLogo">Block logo</title>
    <path
      d="M13.5641 34.5126C10.3954 34.5126 8.0654 33.2544 6.52763 31.4371V34H0.935742V0.541856H6.52763V12.145C8.0654 10.3277 10.3954 9.06949 13.5641 9.06949C20.4142 9.06949 24.3285 14.8478 24.3285 21.791C24.3285 28.7343 20.4142 34.5126 13.5641 34.5126ZM6.38784 21.0921V22.5366C6.38784 27.0567 8.99738 29.6197 12.4457 29.6197C16.4998 29.6197 18.69 26.4509 18.69 21.791C18.69 17.1311 16.4998 13.9624 12.4457 13.9624C8.99738 13.9624 6.38784 16.4787 6.38784 21.0921ZM34.7073 0.541856V34H29.1154V0.541856H34.7073ZM63.0905 21.791C63.0905 29.3867 58.1976 34.5126 51.301 34.5126C44.4043 34.5126 39.5114 29.3867 39.5114 21.791C39.5114 14.1954 44.4043 9.06949 51.301 9.06949C58.1976 9.06949 63.0905 14.1954 63.0905 21.791ZM45.1499 21.791C45.1499 26.7771 47.5265 29.8061 51.301 29.8061C55.0755 29.8061 57.4521 26.7771 57.4521 21.791C57.4521 16.8049 55.0755 13.776 51.301 13.776C47.5265 13.776 45.1499 16.8049 45.1499 21.791ZM71.9633 21.791C71.9633 26.7771 74.5729 29.6663 78.394 29.6663C81.3763 29.6663 83.1937 27.7091 83.8927 25.0064L88.6924 27.4295C87.4342 31.3905 83.7063 34.5126 78.394 34.5126C71.4041 34.5126 66.3714 29.3401 66.3714 21.791C66.3714 14.242 71.4041 9.06949 78.394 9.06949C83.6597 9.06949 87.2944 12.0518 88.5992 15.9662L83.8927 18.5291C83.1937 15.873 81.3763 13.8692 78.394 13.8692C74.5729 13.8692 71.9633 16.8049 71.9633 21.791ZM98.1312 0.541856V19.8339L107.544 9.53548H114.394L105.168 19.0417L115.14 34H108.663L101.347 22.956L98.1312 26.218V34H92.5393V0.541856H98.1312Z"
      fill="black"
    />
  </svg>
{:else}
  <svg
    focusable="false"
    width="200"
    height="28"
    viewBox="0 0 200 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-labelledby="blockLogo"
    role="img"
  >
    <title id="blockLogo">Block logo</title>
    <path
      d="M138.735 27.6325C149.321 27.6325 154.146 25.242 155.154 18.2536H147.636C146.703 20.9589 144.532 22.0346 137.464 22.0346H136.005C127.145 22.0346 125.496 20.2179 125.496 14.7196V13.867C125.496 8.34486 127.141 6.52806 136.002 6.52806H137.448C144.516 6.52806 146.687 7.6038 147.619 10.3091H155.137C154.13 3.34068 149.305 0.930237 138.719 0.930237H134.698C122.578 0.930237 118.017 4.15745 118.017 13.349V15.2017C118.017 24.3933 122.578 27.6206 134.698 27.6206L138.735 27.6325Z"
      fill="black"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M112.638 15.2135C112.638 24.4051 107.924 27.6323 95.4741 27.6323H91.3583C78.9395 27.6323 74.2261 24.4051 74.2261 15.2135V13.3609C74.2261 4.16928 78.9434 0.942046 91.3583 0.942046H95.4741C107.924 0.942046 112.638 4.16928 112.638 13.3609V15.2135ZM92.5535 22.0544H94.3141V22.0345C103.514 21.9946 105.195 20.2177 105.195 14.7195V13.8987C105.195 8.37661 103.514 6.59566 94.3141 6.55981H92.5535C83.3022 6.59566 81.7085 8.37661 81.7085 13.8987V14.7514C81.7085 20.2376 83.3181 22.0145 92.5535 22.0544Z"
      fill="black"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M34.8303 19.6244V20.1821C34.8303 25.4055 31.866 27.2621 23.527 27.27H0.0400391V1.32086H22.7501C30.866 1.32086 34.0812 2.76713 34.0812 7.54819V7.91075C34.0812 11.8113 32.2485 13.405 29.2205 13.8034V13.9907C32.5473 14.2497 34.7545 15.6959 34.8303 19.6244ZM21.9652 6.79916H7.37898V11.3969H22.1485C25.6625 11.3969 26.7463 10.879 26.7463 9.20961V9.06219C26.7463 7.3171 25.6665 6.79916 21.9652 6.79916ZM27.5033 19.1064C27.5033 16.9828 26.2283 16.5844 21.9253 16.5844L7.37898 16.5924V21.7719H21.9253C26.2681 21.7719 27.5033 21.2938 27.5033 19.2539V19.1064Z"
      fill="black"
    />
    <path
      d="M69.8557 27.262V21.2538H48.5362V1.33267H41.2092V27.2819L69.8557 27.262Z"
      fill="black"
    />
    <path
      d="M168.683 27.2618V19.1021L174.629 15.6557H174.852L189.139 27.2578H200L181.114 11.9863L199.478 1.3086H188.278L168.871 12.6875H168.683V1.31256H161.353V27.2618H168.683Z"
      fill="black"
    />
  </svg>
{/if}
